import { Checkbox } from '@ark-ui/react/checkbox';
import { type Finding } from '@consigli/types';
import clsx from 'clsx';
import { type FC } from 'react';

import { AddContextCheckboxControl } from './add-context-checkbox';
import { FindingCardBody } from './finding-card-body';

interface AddContextFindingCardProps {
  finding: Finding;
  onSelectedChange: (selected: boolean) => void;
  selected: boolean;
}

/*
 * The card is the checkbox's label, so the whole row toggles on click and the
 * hidden input carries the keyboard behaviour. Nothing else in the card is
 * interactive, so there is no control nested inside the label.
 *
 * The row's own measurements live with the column in `FindingCardBody`,
 * which the read-only sources list draws from the same source.
 */
export const AddContextFindingCard: FC<AddContextFindingCardProps> = ({
  finding,
  onSelectedChange,
  selected,
}) => {
  return (
    <Checkbox.Root
      checked={selected}
      onCheckedChange={({ checked }) => onSelectedChange(checked === true)}
      className={clsx(
        'flex w-full shrink-0 cursor-pointer items-start gap-[var(--ds-space-4)] overflow-hidden rounded-[var(--ds-radius-16)] border border-solid p-[var(--ds-space-6)] text-left',
        selected
          ? 'border-[var(--ds-color-raw-neutral-300)] bg-[var(--ds-color-bg-brand-lighter)]'
          : 'border-[var(--ds-color-border-primary)] bg-[var(--ds-color-bg-primary)]',
      )}
    >
      <Checkbox.HiddenInput />
      <AddContextCheckboxControl />
      <FindingCardBody finding={finding} />
    </Checkbox.Root>
  );
};
